import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import addIcon from "@icons/ic-add-green.svg";
import deleteIcon from "@icons/ic-delete-red.svg";

import {
  FileInputLabel,
  FileImageWrapper,
  FileInput,
  DocumentRow,
  FileName,
  DeleteSpan,
} from "./DocumentUpload.styled";

const DocumentUpload = (props) => {
  const {
    t,
    isEditMode,
    setFormData,
    formData,
    selectedProduct,
    existingDocuments,
    setExistingDocuments,
    title,
    addMore,
  } = props;

  const onFileSelect = (e) => {
    let filesArray = formData.documents;
    for (let i = 0; i < e.target.files.length; i++) {
      filesArray.push(e.target.files[i]);
    }
    setFormData({
      ...formData,
      documents: filesArray,
    });
  };

  const deleteFile = (index) => {
    const fileListArr = Array.from(formData.documents);
    fileListArr.splice(index, 1); // here u remove the file

    // recreate file object
    let updatedDocs = [];
    const dT = new DataTransfer();
    if (fileListArr.length > 0) {
      for (let file of fileListArr) {
        dT.items.add(file);
      }
      updatedDocs = dT.files;
    }
    setFormData({
      ...formData,
      documents: updatedDocs,
    });
  };
  const deleteExistingFile = (id) => {
    const documents = existingDocuments.filter((item) => item.id !== id);
    setExistingDocuments(documents);
  };

  useEffect(() => {
    if (selectedProduct && isEditMode) {
      setExistingDocuments(selectedProduct.documents);
    }
  }, [selectedProduct, isEditMode]);

  const getDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            <Image
              className="deleteImage"
              src={deleteIcon}
              alt="delete"
              onClick={() => deleteFile(i)}
              styles={{ width: "auto" }}
            />
          </DeleteSpan>{" "}
          {files[i].name}
        </FileName>
      );
    }
    return docs;
  };

  const getExistingDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            <Image
              className="deleteImage"
              src={deleteIcon}
              alt="delete"
              onClick={() => deleteExistingFile(files[i].id)}
              styles={{ width: "auto" }}
            />
          </DeleteSpan>{" "}
          {files[i].fileName}{" "}
        </FileName>
      );
    }
    return docs;
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <FileInputLabel>{t(title)}</FileInputLabel>
        {!!addMore && (
          <FileImageWrapper htmlFor="document">
            <Image
              src={addIcon}
              alt="upload Analytical note."
              styles={{ width: "auto" }}
            />
          </FileImageWrapper>
        )}
        <FileInput type="file" id="document" multiple onChange={onFileSelect} />
      </div>
      {isEditMode && (
        <DocumentRow>
          {existingDocuments?.length > 0 &&
            getExistingDocumentList(existingDocuments)}
          {formData.documents.length > 0
            ? getDocumentList(formData.documents)
            : ""}
        </DocumentRow>
      )}
      {!isEditMode && formData.documents.length > 0 && (
        <DocumentRow> {getDocumentList(formData.documents)} </DocumentRow>
      )}
    </>
  );
};

DocumentUpload.propTypes = {
  title: PropTypes.string,
  addMore: PropTypes.number,
};

DocumentUpload.defaultProps = {
  title: "DOCUMENTS",
  addMore: true,
};

export default withTranslation()(DocumentUpload);
